import { render, staticRenderFns } from "./FuSpeedDialActionButton.vue?vue&type=template&id=c752d2f4&"
import script from "./FuSpeedDialActionButton.vue?vue&type=script&lang=js&"
export * from "./FuSpeedDialActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports